<template>
    <div class="origo-user-guide-component">
        <div class="container h-100 user-guide-content">
            <div class="row h-100 align-items-center">
                <div class="col-12">
                    <div class="d-flex flex-column">
                        <div class="row">
                            <div class="col-12">
                                <slick
                                    ref="slick"
                                    :options="slickOptions"
                                    @afterChange="handleAfterChange"
                                    @beforeChange="handleBeforeChange"
                                    @breakpoint="handleBreakpoint"
                                    @destroy="handleDestroy"
                                    @edge="handleEdge"
                                    @init="handleInit"
                                    @reInit="handleReInit"
                                    @setPosition="handleSetPosition"
                                    @swipe="handleSwipe"
                                    @lazyLoaded="handleLazyLoaded"
                                    @lazyLoadError="handleLazeLoadError">
                                    <div>

                                        <div class="row">
                                            <div class="col-8">
                                                <h1>{{ userGuideStepOneSubHeading }}</h1>
                                                <h3>{{ userGuideStepOneStepCount }}</h3>
                                                <h2>{{ userGuideStepOneHeading }}</h2>
                                                <p>{{ userGuideStepOneDescription }}</p>
                                            </div>
                                            <div class="col-4">
                                                <div class="d-flex flex-row justify-content-center align-items-center h-100">
                                                    <img src="/images/origo-policy-doc-icon.png" style="width:250px; height:250px;" alt="Policy & Acceptance">
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div>

                                        <div class="row">
                                            <div class="col-8">
                                                <h1>{{ userGuideStepTwoSubHeading }}</h1>
                                                <h3>{{ userGuideStepTwoStepCount }}</h3>
                                                <h2>{{ userGuideStepTwoHeading }}</h2>
                                                <p>{{ userGuideStepTwoDescription }}</p>
                                            </div>
                                            <div class="col-4">
                                                <div class="d-flex flex-row justify-content-center align-items-center h-100">
                                                    <img src="/images/origo-detail-confirmation-icon.png" style="width:250px; height:250px;" alt="Detail confirmation">
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div>

                                        <div class="row">
                                            <div class="col-8">
                                                <h1>{{ userGuideStepThreeSubHeading }}</h1>
                                                <h3>{{ userGuideStepThreeStepCount }}</h3>
                                                <h2>{{ userGuideStepThreeHeading }}</h2>
                                                <p>{{ userGuideStepThreeDescription }}</p>
                                            </div>
                                            <div class="col-4">
                                                <div class="d-flex flex-row justify-content-center align-items-center h-100">
                                                    <img src="/images/origo-vehicle-selection-icon.png" style="width:250px; height:250px;" alt="Vehicle selection">
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div>

                                        <div class="row">
                                            <div class="col-8">
                                                <h1>{{ userGuideStepFourSubHeading }}</h1>
                                                <h3>{{ userGuideStepFourStepCount }}</h3>
                                                <h2>{{ userGuideStepFourHeading }}</h2>
                                                <p>{{ userGuideStepFourDescription }}</p>
                                            </div>
                                            <div class="col-4">
                                                <div class="d-flex flex-row justify-content-center align-items-center h-100">
                                                    <img src="/images/origo-comparison-icon.png" style="width:250px; height:250px;" alt="Side by side comparison">
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div>

                                        <div class="row">
                                            <div class="col-8">
                                                <h1>{{ userGuideStepFiveSubHeading }}</h1>
                                                <h3>{{ userGuideStepFiveStepCount }}</h3>
                                                <h2>{{ userGuideStepFiveHeading }}</h2>
                                                <p>{{ userGuideStepFiveDescription }}</p>
                                            </div>
                                            <div class="col-4">
                                                <div class="d-flex flex-row justify-content-center align-items-center h-100">
                                                    <img src="/images/origo-place-your-order-icon.png" style="width:250px; height:250px;" alt="Place your order">
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </slick>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer-text v-if="footerText" :footerText="footerText" />
    </div>
</template>

<script>

import Slick from 'vue-slick';
import FooterText from './footer/footer-text';

export default {

    components: {FooterText, Slick},

    data() {
        return {
            slickOptions: {
                slidesToShow: 1,
                dots: true,
                infinite: false,
                cssEase: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
                speed: 750,
            }
        };
    },

    props: [
        'adminPortalData',
        'adminPortalPrimaryProduct'
    ],

    computed: {
        userGuideStepOneDescription() {
            return this.adminPortalPrimaryProduct.user_guide_step_one_description;
        },
        userGuideStepOneHeading() {
            return this.adminPortalPrimaryProduct.user_guide_step_one_heading;
        },
        userGuideStepOneStepCount() {
            return this.adminPortalPrimaryProduct.user_guide_step_one_step_count;
        },
        userGuideStepOneSubHeading() {
            return this.adminPortalPrimaryProduct.user_guide_step_one_sub_heading;
        },
        userGuideStepTwoDescription() {
            return this.adminPortalPrimaryProduct.user_guide_step_two_description;
        },
        userGuideStepTwoHeading() {
            return this.adminPortalPrimaryProduct.user_guide_step_two_heading;
        },
        userGuideStepTwoStepCount() {
            return this.adminPortalPrimaryProduct.user_guide_step_two_step_count;
        },
        userGuideStepTwoSubHeading() {
            return this.adminPortalPrimaryProduct.user_guide_step_two_sub_heading;
        },
        userGuideStepThreeDescription() {
            return this.adminPortalPrimaryProduct.user_guide_step_three_description;
        },
        userGuideStepThreeHeading() {
            return this.adminPortalPrimaryProduct.user_guide_step_three_heading;
        },
        userGuideStepThreeStepCount() {
            return this.adminPortalPrimaryProduct.user_guide_step_three_step_count;
        },
        userGuideStepThreeSubHeading() {
            return this.adminPortalPrimaryProduct.user_guide_step_three_sub_heading;
        },
        userGuideStepFourDescription() {
            return this.adminPortalPrimaryProduct.user_guide_step_four_description;
        },
        userGuideStepFourHeading() {
            return this.adminPortalPrimaryProduct.user_guide_step_four_heading;
        },
        userGuideStepFourStepCount() {
            return this.adminPortalPrimaryProduct.user_guide_step_four_step_count;
        },
        userGuideStepFourSubHeading() {
            return this.adminPortalPrimaryProduct.user_guide_step_four_sub_heading;
        },
        userGuideStepFiveDescription() {
            return this.adminPortalPrimaryProduct.user_guide_step_five_description;
        },
        userGuideStepFiveHeading() {
            return this.adminPortalPrimaryProduct.user_guide_step_five_heading;
        },
        userGuideStepFiveStepCount() {
            return this.adminPortalPrimaryProduct.user_guide_step_five_step_count;
        },
        userGuideStepFiveSubHeading() {
            return this.adminPortalPrimaryProduct.user_guide_step_five_sub_heading;
        },
        footerText() {
            return this.adminPortalData.content?.products?.ecoamaps
                && this.adminPortalData.content?.products?.ecoamaps[0]?.fca_requirement_and_content_fca_description_required
                && this.adminPortalData.content?.products?.ecoamaps[0]?.fca_requirement_and_content_fca_description
                && this.adminPortalData.content?.products?.ecoamaps[0]?.fca_description_required_on_user_guide
                ? this.adminPortalData.content.products.ecoamaps[0].fca_requirement_and_content_fca_description
                : false;
        }
    },

    methods: {

        next() {
            this.$refs.slick.next();
        },

        prev() {
            this.$refs.slick.prev();
        },

        reInit() {
            this.$nextTick(() => {
                this.$refs.slick.reSlick();
            });
        },

        // Events listeners
        handleAfterChange(event, slick, currentSlide) {
            var title = 'Skip intro and continue';

            if (slick.currentSlide === slick.slideCount - 1) {
                title = 'Continue';
            }

            this.$parent.nextPageTitle = title;
        },
        handleBeforeChange(event, slick, currentSlide, nextSlide) {
            //console.debug('handleBeforeChange', event, slick, currentSlide, nextSlide);
        },
        handleBreakpoint(event, slick, breakpoint) {
            //console.debug('handleBreakpoint', event, slick, breakpoint);
        },
        handleDestroy(event, slick) {
            //console.debug('handleDestroy', event, slick);
        },
        handleEdge(event, slick, direction) {
            //console.debug('handleEdge', event, slick, direction);
        },
        handleInit(event, slick) {
            //console.debug('handleInit', event, slick);
        },
        handleReInit(event, slick) {
            //console.debug('handleReInit', event, slick);
        },
        handleSetPosition(event, slick) {
            //console.debug('handleSetPosition', event, slick);
        },
        handleSwipe(event, slick, direction) {
            //console.debug('handleSwipe', event, slick, direction);
        },
        handleLazyLoaded(event, slick, image, imageSource) {
            //console.debug('handleLazyLoaded', event, slick, image, imageSource);
        },
        handleLazeLoadError(event, slick, image, imageSource) {
            //console.debug('handleLazeLoadError', event, slick, image, imageSource);
        },
    },
};

</script>
